module.exports = __webpack_public_path__ + "img/star-blank.6627a67b.svg";